/* eslint-disable max-len */
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import uniqBy from 'lodash/uniqBy'
import orderBy from 'lodash/orderBy'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import { Button } from '../../../buttons'
import { modalButtons } from '../../../buttons/modal-button'
import { SearchSelect } from '../../../input'
import { projectInformationAction } from '../../../../actions'
import { projectInformationSelector, authSelector } from '../../../../selectors'
import { FONTS } from '../../../../constants'
import { criteria } from './constants'

export const ActionBar = props => {
  const [lobs, setLobs] = useState([])
  const {
    invalidList,
    hideEdit,
    rSelected,
    projectByID = {},
    editProjectInformation,
    getProjectInformationByID,
    lobData = [],
    selectedLOB,
    setLOB,
  } = props
  const dispatch = useDispatch()
  const authData = useSelector(authSelector.getAuth)
  const isAccountantRole = authData.user && authData.user.is_accountant_role
  const isKeyPM = authData.user && authData.user._id === projectByID.key_project_manager_id
  const isEdit = useSelector(projectInformationSelector.getIsEditRevenuePlanning)
  const canEditAllocation = useSelector(projectInformationSelector.getCanEditAllocation)
  const { revenue_allocation = [] } = projectByID
  const isInvalid = revenue_allocation.some(r => r.lobs.some(l => l.criteria !== criteria.MD && parseFloat(l._sumLobTotalRatio) > 100))
  const presale_snapshot = projectByID && projectByID.presale_snapshot ? projectByID.presale_snapshot.snapshot : null
  const isPresale = presale_snapshot && rSelected === 1
  const showEdit = !isPresale && projectByID.$can_edit
  const canSave = !Object.values(invalidList).some(v => v) && !isInvalid

  useEffect(() => {
    if (projectByID.revenue_allocation) {
      const list = [{ label: 'All LOB', value: '' }]
      projectByID.revenue_allocation.map(r => {
        const lobs = uniqBy(r.lobs, 'lob_id')
        lobs.map(l => {
          const lob = lobData.find(v => v._id === l.lob_id)
          if (lob) list.push({ label: lob.name, value: lob._id })
          return l
        })
        return r
      })
      setLobs(orderBy(uniqBy(list, 'value'), 'label', 'asc'))
    }
  }, [projectByID.revenue_allocation])

  const handleClickEdit = () => {
    dispatch(projectInformationAction.editRevenuePlanningTable(!isEdit))
  }

  const handleClickCancel = () => {
    dispatch(projectInformationAction.editRevenuePlanningTable(!isEdit))
    getProjectInformationByID()
  }

  const handleClickSave = () => {
    if (!canSave) {
      const actions = { close: closeResponseModal }
      dispatch(projectInformationAction.openResponseModal({
        responseModal: {
          isOpen: true,
          res: {
            type: 'error',
            title: 'Error',
            description: (
              <WarningWrapper>
                <ul>
                Please make sure the revenue or percentage are correct.
                Please recheck the follow:
                  <li><span>Criteria must not be empty</span></li>
                  <li><span>LOB must not be empty</span></li>
                </ul>
              </WarningWrapper>
            ),
            actions: modalButtons('error', actions),
          },
        },
      }))
    } else {
      dispatch(projectInformationAction.editRevenuePlanningTable(!isEdit))
      const payload = { ...projectByID }
      delete payload.project_type
      delete payload.created
      delete payload.project_approve_status
      delete payload.created_by
      delete payload.project_number
      delete payload.__v
      delete payload.project_status
      delete payload._id
      delete payload.updated_by
      editProjectInformation(payload)
    }
  }

  const closeResponseModal = () => {
    dispatch(projectInformationAction.openResponseModal({
      responseModal: { isOpen: false, res: {} },
    }))
  }

  return (
    <Root>
      <SearchWrapper>
        <SearchSelect
          name='lob'
          placeholder='Select LOB'
          options={ lobs }
          value={ selectedLOB }
          onChange={ e => setLOB(e) }
        />
      </SearchWrapper>
      { showEdit && !isEdit && !hideEdit &&
      <EditPriceWrapper disabled={ !(canEditAllocation || isAccountantRole || isKeyPM) }>
        <Button
          width='70px'
          height='26px'
          theme='#28a745'
          onClick={ handleClickEdit }
          disabled={ !(canEditAllocation || isAccountantRole || isKeyPM) }
          icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
        >
        Edit
        </Button>
        <div id='tooltip'>Only the owner of this LOB can edit this page</div>
      </EditPriceWrapper>
      }
      { isEdit &&
        <ButtonWrapper>
          {/* <SaveWrapper disabled={ !canSave }> */}
          <Button
            width='70px'
            height='26px'
            theme='#28a745'
            // disabled={ !canSave }
            onClick={ handleClickSave }
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            style={ { marginRight: 12 } }
          >
            Save
          </Button>
          {/* <div id='tooltip-save'>
              <ul>
                Please make sure the revenue or percentage are correct.
                Please recheck the follow:
                <li><span>Criteria must not be empty</span></li>
                <li><span>LOB must not be empty</span></li>
              </ul>
            </div>
          </SaveWrapper> */}
          <Button
            width='70px'
            height='26px'
            theme='#6c757d'
            onClick={ handleClickCancel }
          >
            Cancel
          </Button>
        </ButtonWrapper>
      }
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 16px;
`

const ButtonWrapper = styled.div`
  display: flex;
`

const SearchWrapper = styled.div`
  width: 200px;
`

const EditPriceWrapper = styled.div`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  position: relative;

  #tooltip {
    position: absolute;
    left: -330px;
    top: -3px;
    padding: 8px 12px;
    background: #FFFFFF;
    border: 1px solid #EAEAEA;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    color: #808080;
    font-family: ${FONTS.GOTHAM};
    font-size: ${FONTS.SMALL_SIZE};
    transition: opacity 0s ease;
    opacity: 0;
    visibility: hidden;
  }

  :hover {
  ${p => (p.disabled && `
    #tooltip {
      transition: opacity 0s ease;
      transition-delay: 1s;
      opacity: 1;
      visibility: visible;
    }
    `)}
  }
`

// const SaveWrapper = styled.div`
//   font-family: ${FONTS.GOTHAM_MEDIUM};
//   font-size: ${FONTS.SMALL_SIZE};
//   position: relative;
//   margin-right: 12px;

//   #tooltip-save {
//     max-width: 400px;
//     position: absolute;
//     left: -410px;
//     top: 0;
//     padding: 8px 12px;
//     background: #FFFFFF;
//     border: 1px solid #EAEAEA;
//     box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
//     border-radius: 4px;
//     color: #808080;
//     font-family: ${FONTS.GOTHAM};
//     font-size: ${FONTS.SMALL_SIZE};
//     transition: opacity 0s ease;
//     opacity: 0;
//     visibility: hidden;
//     z-index: 1;

//     ul {
//       padding: 0;
//       margin: 0 12px;
//       list-style-type: none;
//     }

//     li:before {
//       content:'\\2022';
//       font-size: 16px;
//       border-radius: 50%;
//       line-height: 0;
//       vertical-align: middle;
//       margin-right: 4px;
//     }
//   }

//   :hover {
//   ${p => (p.disabled && `
//     #tooltip-save {
//       transition: opacity 0s ease;
//       transition-delay: 1s;
//       opacity: 1;
//       visibility: visible;
//     }
//     `)}
//   }
// `

const WarningWrapper = styled.div`
  color: #808080;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};

  ul {
      padding: 0;
      list-style-type: none;
    }

    li:before {
      content:'\\2022';
      font-size: 16px;
      border-radius: 50%;
      line-height: 0;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/action-bar.js